import { Input } from "@mui/material";
import { GoogleMap, useJsApiLoader } from "@react-google-maps/api";
import { useEffect, useState } from "react";
import {
  getCountry,
  getGeoLocation,
  getLocationInfoByAddress,
} from "../../API/api";
import { getParamsValue } from "../../Utilities/helperFunction";

const libraries = ["places"];

const Location = ({
  mock,
  setScrollDisable,
  name,
  setMaintainValues,
  maintainValues,
  setValue,
}) => {
  const gMapKey = process.env.REACT_APP_GMAP_KEY;
  const [center, setCenter] = useState({ lat: 10.99835602, lng: 77.01502627 });
  const [address, setAddress] = useState("");
  const [searchAddress, setSearchAddress] = useState("");
  const [restAddress, setRestAddress] = useState(true);

  const containerStyle = {
    width: "600px",
    height: "350px",
  };

  const { isLoaded } = useJsApiLoader({
    googleMapsApiKey: gMapKey || "",
    libraries,
  });

  const handleClick = async (e) => {
    const lat = e.latLng.lat();
    const lng = e.latLng.lng();
    const locationRes = await getGeoLocation(lat, lng);
    const locData = locationRes?.data?.[0];
    setAddress(locData?.formattedAddress);
  };

  useEffect(() => {
    if (!maintainValues[name]) {
      const inputVal = getParamsValue(name);
      setValue(name, inputVal);
      setMaintainValues({ ...maintainValues, [`${name}`]: inputVal });
    }
  }, []);

  useEffect(() => {
    if (!isLoaded) return;

    const load = async () => {
      let countryRes = await getCountry();

      if (countryRes?.status === 200 && countryRes?.data) {
        let str = countryRes.data;
        str = str.replace("geoip(", "").replace(")", "");
        str = JSON.parse(str);
        const { city } = str;

        if (city) {
          const locationInfo = await getLocationInfoByAddress(city);
          setCenter({
            lat: locationInfo?.data[0]?.latitude,
            lng: locationInfo?.data[0]?.longitude,
          });
        }
      }
    };

    load();
  }, [isLoaded, restAddress]);

  useEffect(() => {
    setValue(name, address);
    setMaintainValues({ ...maintainValues, [`${name}`]: address });
  }, [address]);

  useEffect(() => {
    if (!searchAddress) {
      setRestAddress(!restAddress);
      return;
    }
    const delayDebounce = setTimeout(async () => {
      const locationInfo = await getLocationInfoByAddress(searchAddress);

      setCenter({
        lat: locationInfo?.data[0]?.latitude,
        lng: locationInfo?.data[0]?.longitude,
      });
    }, 600);

    return () => clearTimeout(delayDebounce);
  }, [searchAddress]);

  if (!isLoaded) return <div className="input-container">Loading map...</div>;

  return (
    <div
      className="input-container"
      onMouseEnter={() => setScrollDisable(true)}
      onMouseLeave={() => setScrollDisable(false)}
    >
      <div>
        <Input
          type="text"
          placeholder="search address"
          value={searchAddress}
          onChange={(e) => setSearchAddress(e.target.value)}
          style={{
            width: "100%",
            padding: "8px",
            boxSizing: "border-box",
            margin: "10px 0",
          }}
        />
      </div>
      <GoogleMap
        mapContainerStyle={containerStyle}
        center={center}
        zoom={15}
        onClick={(e) => {
          handleClick(e);
        }}
      ></GoogleMap>
      <div style={{ marginTop: "10px" }}>
        <div>
          <strong>Selected Location:</strong>
        </div>
        <div>{address || "Click on the map to select a location"}</div>
        <div
          style={{ fontSize: "12px", color: "#666", marginTop: "5px" }}
        ></div>
      </div>
    </div>
  );
};

export default Location;
